<template>
  <div id="tryout-group">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Video Pembelajaran</li>
      <li class="active">Daftar Video</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Video</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-success btn-xs" @click="createVideo()"><span class="fa fa-plus"></span> Tambah Video</button>
            </div>
            <h4 class="panel-title">Video Pembelajaran</h4>
          </div>
          <div class="panel-body">
            <app-datatable :items="videoList" :has-action="true" :has-preview="true" :headers="headers"
              v-on:selected="selectedRow = $event" v-on:dblClicked="editVideo()"
              v-on:deleted="deleteVideo($event)"></app-datatable>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import DataTable from '@/components/plugins/DataTable'
import TryoutService from '@/services/tryout.js'
import VideoService from '@/services/video.js'
import AppSpinner from '@/components/plugins/Spinner'
import Moment from 'moment'
import Modal from '@/components/plugins/Modal'

export default
{
  name: 'tryout-group',
  components: {
    'app-datatable': DataTable,
    'app-spinner': AppSpinner
  },
  data: function() {
    return {
      videoList: [],
      selectedRow: null,
      isLoading: false,
      headers: ['Judul', 'Kelas', 'Mata Pelajaran'],
      showModal: false
    }
  },
  mounted: function() {
    this.fetchData()
    this.$store.commit('video_reset')
  },
  methods: {
    fetchData: function() {
      this.videoList = []
      var context = this
      VideoService.getListVideo( (result) => {
        if (result.success) {
          result.data.forEach(function(video) {
            var gradeWrap = ''
            if(video.grades.length > 0){
              for (var i =0; i < video.grades.length; i++){
                gradeWrap += ' '+ video.grades[i].grade
              }
            } else {
              gradeWrap = ''
            }
            var row = {
                      id: video.id,
                      url: video.youtube_url,
                      data: [video.title, gradeWrap, video.mapel.nama],
                      }
            context.videoList.push(row)
          })
        }
      })
    },
    createVideo: function() {
      this.$router.push({path: '/video/form'})
    },
    editVideo: function() {
      var context = this
      var videoId = this.selectedRow.id
      this.$router.push({path: '/video/form', query: {id: videoId}})
    },
    deleteVideo: function(video) {
      var context = this
      var videoId = video.id
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
      if (confirmed) {
        this.isLoading = true
        VideoService.deleteVideo(videoId, (result) => {
          if (result.success) {
            alert('Data Terhapus')
            context.isLoading = false
            context.fetchData()
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// VdPembelajaran.vue?57f6a779